import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {getFeatureGroupIconStyles} from "../bvComponent/core/assets";
import SelectionFooterSubSteps from "./selectionFooterSubSteps";
import {getFeatureGroupName} from "../../misc/helpers";
import {injectIntl} from "react-intl";
import SubPartDoneCheckMark from "./subPartDoneCheckMark";

class SelectionFooterSubPart extends Component {

  static propTypes = {
    itemIndex: PropTypes.number.isRequired,
    activePartRelatedItemIndex: PropTypes.number.isRequired,
    navItem: PropTypes.object.isRequired,
    handleFooterButtonClick: PropTypes.func.isRequired,
    withShoppingCart: PropTypes.bool.isRequired,
  };

  state = {
    expanded: true,
    collapsing: false
  };

  componentDidMount() {
    if (!this.props.withShoppingCart && (this.props.itemIndex === this.props.activePartRelatedItemIndex)) {
      this.collapseRing();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.withShoppingCart) {
      if ((this.props.itemIndex === this.props.activePartRelatedItemIndex) && (nextProps.itemIndex !== nextProps.activePartRelatedItemIndex)) {
        this.expandRing();
      } else if ((this.props.itemIndex !== this.props.activePartRelatedItemIndex) && (nextProps.itemIndex === nextProps.activePartRelatedItemIndex)) {
        this.collapseRing();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.expandTimeoutId)
  }

  collapseRing = () => {
    this.expandTimeoutId = setTimeout(() => {
      this.setState({
        expanded: false
      })
    }, 300)
  }

  expandRing = () => {
    clearTimeout(this.expandTimeoutId)
    this.setState({
      expanded: false,
      collapsing: true
    }, () => {
      this.expandTimeoutId = setTimeout(() => {
        this.setState({
          expanded: true,
          collapsing: false
        })
      }, 500)
    })
  }

  render() {
    const {navItem, handleFooterButtonClick, itemIndex, intl, fabricatorData, activePartRelatedItemIndex,
      withShoppingCart, activeTheme} = this.props;

    let name = getFeatureGroupName(navItem.part, intl, fabricatorData);
    if (!navItem.part.customGroupDisplayName && (name === "Countertop") && (navItem.part.partId === "center_island_countertop")) {
      name = "Island Countertop";
    }
    const isActive = itemIndex === activePartRelatedItemIndex && !withShoppingCart;
    return (
      <Fragment>
        <button className={"selection-footer-list__item selection-footer-list__item--"+navItem.part.partId
        + (isActive ? " selection-footer-list__item--active" : "")}
                onClick={() => { handleFooterButtonClick(itemIndex) }}>
          {isActive || this.state.collapsing ? (
            <div className={"white-ring" + (this.state.expanded || this.state.collapsing ? " white-ring--expanded" : "")}>
              <div className={"white-ring-expand"}>
                <div className="white-ring-expand__dashes"/>
              </div>
            </div>
          ) : null}
          <div className={"selection-footer-list__item-inner" + (isActive && !this.state.expanded ? " scaled" : "")}>
            <span className="selection-footer-list__item-icon" style={getFeatureGroupIconStyles(navItem.part, activeTheme)}/>
          </div>
          <SubPartDoneCheckMark relatedItem={navItem.part}/>
          <span className="selection-footer-list__item-text">{name}</span>
        </button>
        <SelectionFooterSubSteps isActive={isActive} activeSubPart={navItem}/>
      </Fragment>
    )

    // return (
    //   <div className="selection-footer-active-item">
    //     <button className={"selection-footer-list__item selection-footer-list__item--"+navItem.part.partId + " selection-footer-list__item--active"}
    //             style={{left: offsetLeft}}
    //             onClick={() => { handleFooterButtonClick(activePartRelatedItemIndex) }}>
    //       <div className={"selection-footer-list__item-inner"+ (!this.state.expanded ? " scaled" : "")}>
    //         <div className={"selection-footer-list__item-ring"+ (this.state.expanded ? " expanded" : "")}>
    //           <div className="selection-footer-list__item-ring-dashes"/>
    //         </div>
    //         <span className="selection-footer-list__item-icon" style={getCustomImageStyles(navItem.part)}/>
    //         {partIsSelected(navItem.part) ? <span className="selection-footer-list__item-done"/> : null}
    //       </div>
    //       <span className="selection-footer-list__item-text">{name}</span>
    //     </button>
    //   </div>
    // )
  }
}

const mapStateToProps = (store) => {
  const {subSteps, activeSubStep} = store.selectionState;
  return {
    subSteps,
    activeSubStep,
    fabricatorData: store.fabricatorState,
    activeTheme: store.serverState.activeTheme,
  };
};

export default injectIntl(
  connect(mapStateToProps, {})(SelectionFooterSubPart)
);
